import { V2NftMetadata } from "types";
import * as v2MetadataApi from "api/v2MetadataApi";
import useFetchPromise from "hooks/useFetchPromise";
import useCacheId from "hooks/useCacheId";
import { useMemo } from "react";

const useFetchV2Metadata = (tokenId?: number) => {
  const cacheId = useCacheId();
  const promise = useMemo(
    () => (data: number) => v2MetadataApi.fetchMetadata(data, cacheId),
    [cacheId]
  );

  return useFetchPromise<V2NftMetadata, number>(promise, tokenId);
};

export default useFetchV2Metadata;
